import {
  POST_BUMI_AUTOCOMPLETE_AVISO,
  POST_BUMI_AUTOCOMPLETE_AVISO_SUCCESS,
  POST_BUMI_AUTOCOMPLETE_AVISO_ERROR,
  InitialState,
  CompanyBumiActions,
  CompanyBumiState,
  POST_BUMI_AUTOCOMPLETE_AVISO_RESET,
} from './types'
import { status } from '../../typeStatus'

const AutocompleteAvisoReducer = (
  state: CompanyBumiState = InitialState,
  action: CompanyBumiActions
): CompanyBumiState => {
  switch (action.type) {
    case POST_BUMI_AUTOCOMPLETE_AVISO: {
      return {
        ...state,
        response: null,
        status: status.loading,
      }
    }
    case POST_BUMI_AUTOCOMPLETE_AVISO_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        status: status.success,
      }
    }
    case POST_BUMI_AUTOCOMPLETE_AVISO_ERROR: {
      return {
        ...state,
        response: null,
        status: status.error,
        errorCause: action?.payload,
      }
    }
    case POST_BUMI_AUTOCOMPLETE_AVISO_RESET: {
      return {
        ...state,
        response: null,
        status: status.initial,
      }
    }
    default:
      return state
  }
}

export default AutocompleteAvisoReducer
